import Link from "next/link";

import type { Insight } from "models/insight";

import AlertBox from "components/AlertBox";
import useAuthentication from "hooks/useAuthentication";
import { canonicalUrl } from "utils/envVariables";

const PressPassNote = ({ insight }: { insight: Insight }) => {
  const { account: loggedInAccount } = useAuthentication();

  if (!loggedInAccount?.isPressClient) return null;

  const { author, company } = insight;

  if (!author) return null;

  return (
    <AlertBox title="Important Note for Press Pass Users" className="mb-[10px]">
      <p>
        You are viewing this Insight as part of the exclusive Smartkarma Press
        Pass. We ask that you please remember to source both the Insight
        Provider{" "}
        {author?.slug && (
          <Link
            href={`/${author.isCompany ? "companies" : "profiles"}/${
              author.slug
            }`}
            className="underline"
          >
            {author.name}
          </Link>
        )}{" "}
        AND Smartkarma (
        <a href={canonicalUrl} className="underline">
          www.smartkarma.com
        </a>
        ) and{" "}
        <Link href={`/insights/${insight.slug}`} className="underline">
          link back
        </Link>{" "}
        to the original Insight.
      </p>
      <p>
        An ideal suggested attribution is: &quot;analyst/Insight Provider{" "}
        <Link
          href={`/${author.isCompany ? "companies" : "profiles"}/${
            author.slug
          }`}
          className="underline"
        >
          {author.name}
        </Link>{" "}
        {company && (
          <>
            {" "}
            of{" "}
            <Link href={`/companies/${company.slug}`} className="underline">
              {company.name}
            </Link>
          </>
        )}{" "}
        who publishes on{" "}
        <Link href={`/insights/${insight.slug}`} className="underline">
          Smartkarma
        </Link>
        .&quot;
      </p>
    </AlertBox>
  );
};

export default PressPassNote;
